// TODO This enumerable should be extended if new entities are needed
export enum SimpleListEntitiesAllowedEnum {
    SAMPLE_STATES = 'SAMPLE_STATES',
    CASE_STATE = 'CASE_STATE',
    CASE_TYPE = 'CASE_TYPE',
    PETITIONER = 'PETITIONER',
    REGIME = 'REGIME',
    HEALTH_MANAGEMENT_AREA = 'HEALTH_MANAGEMENT_AREA',
    PRIORITY = 'PRIORITY',
    CENTER = 'CENTER',
    PERSONNEL = 'PERSONNEL',
    PERSONNEL_TECHNICAL = 'PERSONNEL_TECHNICAL',
    PERSONNEL_PATHOLOGIST = 'PERSONNEL_PATHOLOGIST',
    PERSONNEL_EXPERT = 'PERSONNEL_EXPERT',
    PERSONNEL_ADMINISTRATIVE = 'PERSONNEL_ADMINISTRATIVE',
    PERSONNEL_RESIDENT = 'PERSONNEL_RESIDENT',
    PERSONNEL_PORTER = 'PERSONNEL_PORTER',
    PERSONNEL_GUEST = 'PERSONNEL_GUEST',
    PERSONNEL_STUDENT = 'PERSONNEL_STUDENT',
    DEPARTMENT = 'DEPARTMENT',
    PORTION_STATES = 'PORTION_STATES',
    SUBPORTION_STATES = 'SUBPORTION_STATES',
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    PORTION_TYPE = 'PORTION_TYPE',
    SUBPORTION_TYPE = 'SUBPORTION_TYPE',
    TOPOGRAPHIC_CODE = 'TOPOGRAPHIC_CODE',
    PROTOCOL = 'PROTOCOL',
    ASSAY = 'ASSAY',
    ASSAYGROUP = 'ASSAYGROUP'
}

export interface SimpleListEntitiesRequest {
    active?: boolean
    filter?: string
    page?: number
    size?: number
    sort?: string
}

export interface SimpleListEntitiesResponseContent {
    id: (number | string)
    label: string
}

export interface SimpleListEntitiesResponseSort {
    sorted: boolean
    unsorted: boolean
    empty: boolean
}

export interface SimpleListEntitiesResponsePageable {
    sort: SimpleListEntitiesResponseSort
    pageNumber: number
    pageSize: number
    offset: number
    unpaged: boolean
    paged: boolean
}

export interface SimpleListEntitiesResponse {
    content: SimpleListEntitiesResponseContent[]
    pageable: SimpleListEntitiesResponsePageable
    last: boolean
    totalElements: number
    totalPages: number
    first: boolean
    numberOfElements: number
    sort: SimpleListEntitiesResponseSort
    size: number
    number: number
    empty: boolean
}
